import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';
import auth from './auth';
import register from './register';
import dashboard from './dashboard';
import products from './products';
import chat from './chat';

// web profile 
import announcement from './webProfile/Announcement'
import approval from './webProfile/Approval'
import home from './webProfile/Home'
import report from './webProfile/Report'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    layout,
    auth,
    register,
    dashboard,
    products,
    chat,
    announcement,
    approval,
    home,
    report
  },
});
